import React, { useEffect } from "react";
import styles from "./DisclaimerModal.module.css";

const DisclaimerModal = ({ show, onClose }) => {
  useEffect(() => {
    if (show) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
    return () => (document.body.style.overflow = "auto");
  }, [show]);

  if (!show) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} tabIndex={0}>
        <h2>Disclaimer</h2>
        <p>
          The information on this website is for general information purposes
          only and does not constitute legal advice. For specific advice, please
          consult KASIBHATLAWS directly.
        </p>
        <button className={styles.modalBtn} onClick={onClose}>
          I Understand
        </button>
      </div>
    </div>
  );
};

export default DisclaimerModal;
